export default "__VITE_ASSET__J_1qmtPq__"